import { copy } from "../copy";

// Result of a sign-in or registration call. The server's message is shown
// as it is; it never contains markup.
export type AuthResult = { ok: true } | { ok: false; error: string };

async function post(url: string, body: unknown): Promise<AuthResult> {
  let res: Response;
  try {
    res = await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
  } catch {
    return { ok: false, error: copy.auth.network };
  }
  const data = (await res.json().catch(() => null)) as { ok?: unknown; error?: unknown } | null;
  if (res.ok && data?.ok === true) return { ok: true };
  return { ok: false, error: typeof data?.error === "string" ? data.error : copy.auth.network };
}

export function login(email: string, password: string): Promise<AuthResult> {
  return post("/v1/web/login", { email, password });
}

export type Registration = {
  username: string;
  email: string;
  password: string;
  role: string;
  recaptcha_token: string;
  website: string;
};

export function register(input: Registration): Promise<AuthResult> {
  return post("/v1/web/register", input);
}

// The public reCAPTCHA site key, or "" when the server has none.
export async function fetchSiteKey(): Promise<string> {
  try {
    const res = await fetch("/v1/web/auth/config", { credentials: "same-origin", headers: { Accept: "application/json" } });
    if (!res.ok) return "";
    const data = (await res.json()) as { recaptcha_site_key?: unknown };
    return typeof data.recaptcha_site_key === "string" ? data.recaptcha_site_key : "";
  } catch {
    return "";
  }
}

const DEFAULT_NEXT = "/dashboard";

// safeNext keeps a post-sign-in destination on this site: one leading slash,
// no protocol-relative "//", no backslash tricks. Anything else goes to the
// dashboard.
export function safeNext(raw: string | null): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\")) return DEFAULT_NEXT;
  return raw;
}
